const units = {
  toast: {
    error: {
      badResponse: '[Unidad] respuesta incorrecta del servidor',
      create: {},
      edit: {},
    },
    success: {
      create: { default: 'El sitio se creó correctamente' },
      edit: {},
      delete: {
        default: 'Los sitios se eliminaron correctamente',
      },
    },
  },
  headerButtons: {
    create: 'Crear',
    delete: {
      label: 'Eliminar',
      deleteModal: {
        header: 'Eliminar unidades',
        body: 'Está a punto de eliminar {{units}} unidades',
      },
    },
  },

  create: {
    errorToast: {
      message: 'Ocurrió un error. No se pudo crear el sitio',
    },
    duplicateToast: {
      message: 'El sitio con ese nombre ya existe',
    },
    successToast: {
      message: '¡Éxito! El sitio se añadió correctamente',
    },
  },

  edit: {
    errorToast: {
      message: 'Ocurrió un error. No se pudo actualizar el sitio',
    },
    successToast: {
      message: '¡Éxito! El sitio se actualizó correctamente',
    },
  },

  delete: {
    errorToast: {
      message: 'Ocurrió un error. No se pudo eliminar el sitio',
    },
    successToast: {
      message: '¡Éxito! El sitio se eliminó correctamente',
    },
    deleteViewSite: {
      message: 'Ver sitio no se puede eliminar',
    },
  },

  form: {
    header: {
      create: {
        title: 'Crear',
      },

      update: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: 'Detalles',
        fields: {
          name: 'Nombre',
        },
      },
      information: {
        header: 'Información',
        fields: {
          operation: {
            title: 'Operación',
            options: {
              default: 'Default',
              school: 'School',
              NEMT: 'NEMT',
              microtransit: 'Microtransit',
              airportShuttle: 'Airport Shuttle',
              employee: 'Employee',
              deliveries: 'Deliveries',
              evs: 'EVs',
              broker: 'Broker',
            },
          },
          schoolOperationsEnabled: {
            title: 'Permitir escuela',
          },
          employeeOperationsEnabled: {
            title: 'Permitir lugar de trabajo'
          },
        },
      },
      contactUsInformation: {
        header: 'Información de Contacto de la Aplicación Móvil',
        fields: {
          address: 'Dirección',
          phone: 'Teléfono',
          email: 'Correo electrónico',
        },
      },
    },
    valdations: {
      name: {
        required: 'El nombre es obligatorio',
        name: 'Nombre no válido',
      },
    },
  },
  table: {
    headers: {
      name: 'name',
      operation: 'operation',
    },
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
};

export default units;
